import {
	Component,
	EventEmitter,
	forwardRef,
	Input,
	OnChanges,
	OnInit,
	Output,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
	selector: 'mg-input-password',
	templateUrl: './input-password.component.html',
	styleUrls: ['./input-password.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => InputPasswordComponent),
			multi: true,
		},
	],
})
export class InputPasswordComponent implements OnInit, OnChanges {
	@Input() disabled: boolean = false;
	@Input() placeholder: string = '';
	@Input() value: string = '';
	@Output() valueInput = new EventEmitter<string>();

	type = 'password';
	constructor() {}

	ngOnInit(): void {}
	changeMode() {
		if (!this.disabled) {
			this.type = this.type === 'password' ? 'text' : 'password';
		}
	}

	onInput(event: any): void {
		const { value } = event.target;
		this.value = value;
		this.valueInput.emit(this.value);
	}
	ngOnChanges(): void {
		if (this.disabled) {
			this.type === 'password';
		}
	}
}
